import { render, staticRenderFns } from "./empty.vue?vue&type=template&id=d4c23d1a"
import script from "./empty.vue?vue&type=script&lang=js"
export * from "./empty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ModalsConnectionModalWindows: require('/usr/src/app/components/modals/ConnectionModalWindows.vue').default})
